import React from 'react';
import './Styles/Jobs.scss';
import {IoIosArrowForward} from 'react-icons/io';
import { positions } from './data';
const Jobs=()=>{
    return(
        <div className="jobs-position">
            <h1>HostDesign jobs</h1>
            <p>​​​​​​​Champion your ideas and career in a culture that empowers you</p>
            <div className="cards">
                {positions.map((d) =>{
                    return(
                        <Card {...d} />
                    )
                })}
            </div>
        </div>
    )
};
export default Jobs ;

export function Card(props){
    return(
        <div className="position-card"  data-aos="fade-up"
        data-aos-delay={props.delay}>
            <div className="icon-part">
                <div>
                    <div className="circle" style={{ backgroundColor: `${props.bgColor}` }}>
                        <img src={props.icon} />
                    </div>
                </div>
                <p>{props.sub}</p>
            </div>
            
            <div className="content">
              <div className="title">
              <h2>{props.title}</h2>
              <h4>Open</h4>
              </div>
                <p>{props.desc1}</p>
                <div className="arrow">
                 <IoIosArrowForward />
                </div>
            </div>
            {props.title2 ? 
            <div className="content">
              <div className="title">
              <h2>{props.title2}</h2>
             {props.title2 ?  <h4>Open</h4> : null}
              </div>
                <p>{props.desc2}</p>
                {props.title2 ? <div className="arrow">
                 <IoIosArrowForward />
                </div> : null}
            </div>
 : null }
        </div>
    )
};